export default __webpack_public_path__ + "static/media/Chevrons.2fad35aa.svg";